import React from 'react';
import PropTypes from 'prop-types';
import { ModalActions } from '@strava/ui/Modal';

import clsx from '@strava/ui/clsx';
import styles from './OnboardingModalActions.scss';

const OnboardingModalActions = ({ className, children, ...options }) => {
  return (
    <ModalActions className={clsx(className, styles.modalActions)} {...options}>
      {children}
    </ModalActions>
  );
};

OnboardingModalActions.defaultProps = {
  className: null
};

OnboardingModalActions.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default OnboardingModalActions;
